import { Box, SxProps } from "@mui/material";
import "../../css/glass.css";
type GlassProps = {
    children: React.ReactNode;
    sx?: SxProps;
};

export default function Glass({ children, sx }: GlassProps) {
    return (
        <Box className="glass" sx={sx}>
            {children}
        </Box>
    );
}
